import React, {Fragment} from "react";
import {useSelector} from "react-redux";

// Material-UI Core
import {makeStyles} from "@material-ui/core/styles";

// Material Icon
// Custom Component
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import DashboardCard from "../../components/DashboardCard/DashboardCard";

// Custom Style
import styles from "../../styles/jss/components/dashboardStyle";


const useStyles = makeStyles(styles);

function Dashboard() {
    const classes = useStyles();

    // Redux Data
    const userModulesRedux = useSelector((state) => state.userModulesRedux);

    return (
        // console.log(
        //   "User Module (Redux) | Variable: userModuleRedux (dashboard.js)"
        // ),
        // console.log(userModulesRedux),
        // console.log(
        //   "---------------------------------------------------------------------------------"
        // ),
        <Fragment>
            <GridContainer>
                {userModulesRedux !== null
                    ? userModulesRedux.map((res) => {
                        if (res.status && res.rights.accessible) {
                            if (
                                res.path === "/circulation" ||
                                res.path === "/submission" ||
                                res.path === "/pil"
                            ) {
                                return (
                                    <GridItem xs={12} sm={6} md={4} lg={3} key={res.module_seq}>
                                        <DashboardCard
                                            parentModuleName={""}
                                            cardModuleName={res.name}
                                            cardModulePath={res.path}
                                        />
                                    </GridItem>
                                );
                            }
                        }
                    })
                    : ""}
                {userModulesRedux !== null
                    ? userModulesRedux
                        .filter((obj) => obj.path === "#workflow")[0]
                        .childs.map((res) => {
                            if (res.status && res.rights.accessible) {
                                if (res.path === "/rfi" || res.path === "/transmittal") {
                                    let parentModuleName = userModulesRedux.filter(
                                        (obj) => obj.path === "#workflow"
                                    )[0].name;
                                    return (
                                        <GridItem
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={3}
                                            key={res.module_seq}
                                        >
                                            <DashboardCard
                                                parentModuleName={parentModuleName}
                                                cardModuleName={res.name}
                                                cardModulePath={res.path}
                                            />
                                        </GridItem>
                                    );
                                }
                            }
                        })
                    : ""}
            </GridContainer>
        </Fragment>

        // <div>
        //     <GridContainer>
        //         <GridItem xs={12} sm={6} md={4} lg={3}>
        //             <Card>
        //                 <CardHeader color="info" stats icon>
        //                     <CardIcon color="purple">
        //                         <MailIcon />
        //                     </CardIcon>
        //                     <p className={classes.cardCategory}>Circulation</p>
        //                     <h3 className={classes.cardTitle}>30 <small>(UNREAD)</small></h3>
        //                 </CardHeader>

        //                 <CardFooter stats>
        //                 <div className={classes.stats}>
        //                     <ExitToAppIcon />
        //                     <a href="#pablo" onClick={e => e.preventDefault()}>View Circulation</a>
        //                 </div>
        //                 </CardFooter>
        //             </Card>
        //         </GridItem>

        //         <GridItem xs={12} sm={6} md={4} lg={3}>
        //             <Card>
        //                 <CardHeader color="info" stats icon>
        //                     <CardIcon color="green">
        //                         <AccountTreeIcon />
        //                     </CardIcon>

        //                     <p className={classes.cardCategory}>RFI</p>
        //                     <h3 className={classes.cardTitle}>50 <small>(UNREAD)</small></h3>
        //                 </CardHeader>

        //                 <CardFooter stats>
        //                     <div className={classes.stats}>
        //                         <ExitToAppIcon />
        //                         <a href="#pablo" onClick={e => e.preventDefault()}>View RFI</a>
        //                     </div>
        //                 </CardFooter>
        //             </Card>
        //         </GridItem>

        //         <GridItem xs={12} sm={6} md={4} lg={3}>
        //             <Card>
        //                 <CardHeader color="info" stats icon>
        //                     <CardIcon color="blue">
        //                         <AccountTreeIcon />
        //                     </CardIcon>

        //                     <p className={classes.cardCategory}>TSF</p>
        //                     <h3 className={classes.cardTitle}>10 <small>(UNREAD)</small></h3>
        //                 </CardHeader>

        //                 <CardFooter stats>
        //                     <div className={classes.stats}>
        //                         <ExitToAppIcon />
        //                         <a href="#pablo" onClick={e => e.preventDefault()}>View TSF</a>
        //                     </div>
        //                 </CardFooter>
        //             </Card>
        //         </GridItem>

        //         <GridItem xs={12} sm={6} md={4} lg={3}>
        //             <Card>
        //                 <CardHeader color="info" stats icon>
        //                     <CardIcon color="brown">
        //                         <AccountTreeIcon className={classes.menuIconProperties} />
        //                     </CardIcon>

        //                     <p className={classes.cardCategory}>Transmittal</p>
        //                     <h3 className={classes.cardTitle}>50 <small>(UNREAD)</small></h3>
        //                 </CardHeader>

        //                 <CardFooter stats>
        //                     <div className={classes.stats}>
        //                         <ExitToAppIcon />
        //                         <a href="#pablo" onClick={e => e.preventDefault()}>View Transmittal</a>
        //                     </div>
        //                 </CardFooter>
        //             </Card>
        //         </GridItem>

        //         <GridItem xs={12} sm={6} md={4} lg={3}>
        //             <Card>
        //                 <CardHeader color="info" stats icon>
        //                     <CardIcon color="red">
        //                         <AssignmentTurnedInIcon />
        //                     </CardIcon>
        //                     <p className={classes.cardCategory}>Document Approval</p>
        //                     <h3 className={classes.cardTitle}>25 <small>(UNREAD)</small></h3>
        //                 </CardHeader>

        //                 <CardFooter stats>
        //                 <div className={classes.stats}>
        //                     <ExitToAppIcon />
        //                     <a href="#pablo" onClick={e => e.preventDefault()}>View Document Approval</a>
        //                 </div>
        //                 </CardFooter>
        //             </Card>
        //         </GridItem>
        //     </GridContainer>
        // </div>
    );
}

export default Dashboard;
